import { Link } from 'react-router-dom';

const stats = [
  { value: '800+', label: '收录连载漫画' },
  { value: '60万+', label: '追更用户' },
  { value: '48万+', label: '收藏清单' },
  { value: '1.2亿+', label: '更新提醒' },
];

export default function Hero() {
  return (
    <section className="relative isolate flex min-h-[540px] items-center overflow-hidden md:min-h-[640px]">
      <div className="absolute inset-0 -z-10">
        <img
          src="https://readdy.ai/api/search-image?query=stylish%20artistic%20manga%20comic%20illustration%20of%20floating%20open%20books%20and%20colorful%20speech%20bubbles%20with%20stars%20and%20sparkles%2C%20warm%20orange%20amber%20and%20cream%20palette%2C%20soft%20abstract%20wavy%20shapes%2C%20energetic%20and%20playful%2C%20modern%20editorial%20illustration%20style%2C%20clean%20composition%20with%20ample%20negative%20space%2C%20no%20text&width=1600&height=900&seq=hero-bg-comic&orientation=landscape"
          alt="我爱漫画网 追更收藏漫画背景插画"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/55 via-background-950/35 to-background-950/55"></div>
      </div>

      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="mx-auto flex max-w-3xl w-full flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur-sm">
            <i className="ri-notification-3-line text-primary-300"></i>
            漫画迷必备的追更收藏站
          </span>

          <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-5xl lg:text-6xl">
            我爱漫画网 · 追更收藏
            <span className="block text-primary-200">一部不落，不错过每一话</span>
          </h1>

          <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
            收藏正在连载的漫画，开启连载更新提醒，用追漫日历掌握每一部作品的更新节奏。养肥再看也有进度保存，随时接上上次读到的地方。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:gap-4">
            <Link
              to="/comics"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-bookmark-line"></i>
              立即开始追更
            </Link>
            <Link
              to="/calendar"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
            >
              <i className="ri-calendar-line"></i>
              查看追漫日历
            </Link>
          </div>

          <dl className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-6 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label} className="flex flex-col items-center gap-1">
                <dt className="sr-only">{s.label}</dt>
                <dd className="font-heading text-2xl text-background-50 md:text-3xl">{s.value}</dd>
                <dd className="text-xs text-background-100/80 md:text-sm">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}